<pg-header>
  <a
    href="javascript:void(0)"
    class="btn-link toggle-sidebar d-lg-none pg pg-menu"
    (click)="toggleMobileSidebar.emit()"
  ></a>

  <div class="row">
    <img
      src="assets/img/VStudio_Red.svg"
      alt="logo"
      data-src="assets/img/VStudio_Red.svg"
      ui-jq="unveil"
      data-src-retina="assets/img/VStudio_Red.svg"
      width="50"
      height="50"
      (click)="testRequest()"
    />

    <h4 class="font-weight-200 d-lg-block d-none p-l-10" [innerHTML]="getApplicationHeader()"></h4>
  </div>

  <div class="d-flex align-items-center">
    <div class="pull-right d-lg-block d-none">
      <div class="collapse navbar-collapse">
        <ul *ngIf="user" class="navbar-nav d-md-block">
          <li>
            <a
              #anchor
              (click)="onToggle()"
              class="nav-link dropdown-toggle"
              id="profile-dropdown"
              data-toggle="dropdown"
            >
              <!-- Profile image should be set to the profile picture from the id token -->
              <img
                [src]="user.picture"
                alt="Profile picture"
                class="nav-user-profile rounded-circle"
                style="width: 25px"
              />
            </a>
            <kendo-popup
              [anchor]="authAnchor"
              class="login-popup"
              [popupClass]="'login-dropdown-wrapper'"
              *ngIf="showPopup"
            >
              <div class="content px-2">
                <div class="dropdown-header pt-1 p-b-10 p-t-10 p-b-10 fs-6 text-center">
                  <span>{{ user.name }}</span>
                  <br/>
                  <span *ngIf="user.email">({{ user.email }})</span>
                </div>
                <button
                  (click)="logout.emit()"
                  class="btn btn-link dropdown-item p-b-10 fs-6"
                  id="logoutBtn"
                >
                  <fa-icon [icon]="faPowerOff" class="mr-3"></fa-icon> Log out
                </button>
              </div>
            </kendo-popup>
          </li>
        </ul>
      </div>
    </div>
  </div>
</pg-header>
